import { BlogCardProps } from "../../components/Cards/BlogCard/BlogCard";
import Post from "../../interfaces/post";
import formatDate from "./formatDate";

export const baseurl = new Map ([
    ['Blog','blogs'],
    ['Webinar','on-demand-webinars'],
]);

export const getText = (content: any) => (
    content.text? content.text : '' + (content.children?.map(getText).join('') || '')
);

const getTextWithLimit = (limit: number) => (
    (content: any[]) => {
        let text = '', i = 0;
        while (i < content.length && text.length < limit ) {
            text += getText(content[i++]);
        }
        return text;
    }
);

const cmsToBlog = (type: string) => ( post: Post ) : BlogCardProps => {
    return {
        title: post.title,
        body: getTextWithLimit(250)(post.content?.filter(c => c.type === 'p' || !c.type) || []),
        duration: `${post.duration || '5'} min ${type === 'Blog' ? 'read' : 'watch'}`,
        date: formatDate(post.postDate || ''),
        type: type,
        image: post.image?.url,
        tag: post.tags?.[0]?.tag || '',
        linkTo: `/${baseurl.get(type)}/${post.slug}/`
    }
};

export default cmsToBlog;
